<!--<div class="carousel-slider">
    <div class="carousel-slider__header">
        <div class="carousel-slider__title-section">
            <div class="carousel-slider__title">{{ title }}</div>
            <div class="carousel-slider__count" *ngIf="showCount">{{ totalItems }}</div>
        </div>
        <div class="carousel-slider__controls">
            <button class="carousel-slider__nav-button" (click)="previous()" [disabled]="!canGoPrevious"
                [class.carousel-slider__nav-button--disabled]="!canGoPrevious">


                <img class="carousel-navigation-arrow" src="assets/icons/arrow-white-left.svg" alt="Left Arrow">
            </button>
            <button class="carousel-slider__nav-button" (click)="next()" [disabled]="!canGoNext"
                [class.carousel-slider__nav-button--disabled]="!canGoNext">

                <img class="carousel-navigation-arrow" src="assets/icons/arrow-white-right.svg" alt="Right Arrow">

            </button>
        </div>
    </div>

    <div class="carousel-slider__content">
        <div class="carousel-slider__track" [attr.data-animation-key]="animationKey"
            [class.carousel-slider__track--slide-up]="slideDirection === 'up'"
            [class.carousel-slider__track--slide-down]="slideDirection === 'down'">
            <ng-container
                *ngTemplateOutlet="cardTemplate; context: { $implicit: currentItem, index: currentIndex }"></ng-container>
        </div>
    </div>
</div>-->
<!--14-12-2025-->
<div class="carousel-slider">
    <div class="carousel-slider__header">
        <div class="carousel-slider__title-section">
            <div class="carousel-slider__title">{{ title }}</div>
            <div class="carousel-slider__count" *ngIf="showCount">
                {{ currentIndex + 1 }} / {{ totalItems }}
            </div>
        </div>
        <div class="carousel-slider__header-actions">
            <div *ngIf="!isEditMode" class="carousel-slider__controls">
                <button class="carousel-slider__nav-button" (click)="previous()" [disabled]="!canGoPrevious"
                    [class.carousel-slider__nav-button--disabled]="!canGoPrevious">
                    <img class="carousel-navigation-arrow" src="assets/icons/img-image-1.svg" alt="Left">
                </button>
                <button class="carousel-slider__nav-button" (click)="next()" [disabled]="!canGoNext"
                    [class.carousel-slider__nav-button--disabled]="!canGoNext">
                    <img class="carousel-navigation-arrow" src="assets/icons/img-arrow-right-2.svg" alt="Right">
                </button>
            </div>
            <!-- Edit Pencil (only in edit mode) -->
            <ng-container *ngIf="isEditMode">
                <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin
                    #editTrigger="cdkOverlayOrigin">
                    <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <div class="carousel-slider__content" #sliderContainer>
        <div class="carousel-slider__track" [style.transform]="getSliderTransform()">
            <div *ngFor="let item of items; let i = index" class="carousel-slider__item">
                <ng-container *ngTemplateOutlet="cardTemplate; context: { $implicit: item, index: i }">
                </ng-container>
            </div>
        </div>
    </div>
</div>